module.exports = __webpack_public_path__ + "static/milwaukee-ad1859d09cceacad218732e205f5788d.png";